import React from "react";
import { Alert } from "antd";

const SystemMessage = ({
                           message
                       }) => {

    return (
        <Alert
            style={{
                marginBottom: 20
            }}
            type="info"
            showIcon
            message={message?.content || ""}
        />
    );
};

export default SystemMessage;